import styled from '@emotion/styled';

export const IframeExtended = styled.iframe`
  width: 300px;
  height: 300px;
  overflow: hidden;
  border: 0;
  margin: 0;
`;
